/**
 * API base URL resolution — shared by the tRPC client (main.tsx).
 *
 * Deployment models:
 *   1. Same-origin — Manus, Railway single-service, or local dev:
 *      frontend + backend on one host → window.location.origin.
 *   2. Cross-origin — Cloudflare Pages → Railway API:
 *      VITE_API_BASE_URL baked at Pages build time.
 */

const SAME_ORIGIN_HOST_SUFFIXES = [
  ".manus.computer",
  ".manuspre.computer",
  ".manus-asia.computer",
  ".manuscomputer.ai",
  ".manusvm.computer",
  ".manus.space",
  ".up.railway.app",
];

export const isSameOriginDeployment =
  import.meta.env.DEV ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  SAME_ORIGIN_HOST_SUFFIXES.some((suffix) =>
    window.location.hostname.endsWith(suffix)
  );

export const API_BASE = (() => {
  if (isSameOriginDeployment) {
    return window.location.origin;
  }
  const configured = (import.meta.env.VITE_API_BASE_URL ?? "").replace(
    /\/+$/,
    ""
  );
  if (configured) return configured;
  console.warn(
    "[API] VITE_API_BASE_URL not set for cross-origin deployment; falling back to same origin."
  );
  return window.location.origin;
})();

/** Absolute URL for a backend-served path — use for ALL links to /api/*. */
export function apiUrl(path: string): string {
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
